export default __webpack_public_path__ + "static/15_37-2e88fd3d6d450df44d862ef718c03f33.png";